import Dialog from '@/js/components/Dialog'

export default class DialogForgotPasswordMailSuccess extends Dialog {
    name = 'forgot-password-mail-success'

    render() {
        if (this.el) {
            return
        }

        const template = document.getElementById(`dialog-${this.name}`)

        if (!template) {
            console.error('Template not found')
            return
        }

        const dialog = template.content.firstElementChild

        super.render(dialog)
    }

    beforeShow() {
        this.el.querySelector('[data-message]').textContent = this.options.message
    }
}
